import React, { useEffect, useState, useRef } from 'react'
import Swal from 'sweetalert2';


function Home() {


    var materiais = [
        { value: 0.0089, label: 'Cobre' },
        { value: 0.00845, label: 'Latão' },
        { value: 0.0027, label: 'Alumínio' },
        { value: 0.0072, label: 'Ferro Fundido' },
        { value: 0.00886, label: 'Bronze' },
        { value: 0.0079, label: 'Aço Inox' },
        { value: 0.0078, label: 'Aço Carbono' },
        { value: 0.00116, label: 'Plástico industrial (nylon)' },
    ];

    const [material, setMaterial] = useState(null);


    const [frmBarra, setFrmBarra] = useState({ comprimento: null, diametro: null, resultado: null });
    function calcularBarra() {
        if(material===null || material===undefined){
            Swal.fire({
                title: "Atenção!",
                text: "Selecione um material!"
            })
            return;
        }

        var raio = parseFloat(frmBarra.diametro) / 2;

        var resultado = (raio * raio) * Math.PI * parseFloat(material);
        var resultadoPc = (resultado / 1000) * parseFloat(frmBarra.comprimento);

        setFrmBarra({...frmBarra, resultado: resultado, resultadoPc: resultadoPc});
    }


    const [frmBarraQuadrada, setFrmBarraQuadrada] = useState({ comprimento: null, diametro: null, resultado: null });
    function calcularBarraQuadrada() {
        if(material===null || material===undefined){
            Swal.fire({
                title: "Atenção!",
                text: "Selecione um material!"
            })
            return;
        }

        var resultado = (parseFloat(frmBarraQuadrada.lado1) * parseFloat(frmBarraQuadrada.lado2)) * parseFloat(material);
        var resultadoPc = (resultado / 1000) * parseFloat(frmBarraQuadrada.comprimento);

        setFrmBarraQuadrada({...frmBarraQuadrada, resultado: resultado, resultadoPc: resultadoPc});
    }


    const [frmBucha, setFrmBucha] = useState({ comprimento: null, diametro: null, resultado: null });
    function calcularBucha() {
        if(material===null || material===undefined){
            Swal.fire({
                title: "Atenção!",
                text: "Selecione um material!"
            })
            return;
        }
        var raioExterno = parseFloat(frmBucha.externo) / 2;
        var raioInterno = parseFloat(frmBucha.interno) / 2;

        if(raioExterno<raioInterno){
            Swal.fire({
                title: "Atenção!",
                text: "Interno maior que externo!"
            })
            return;
        }


        var externo = (raioExterno * raioExterno) * Math.PI * parseFloat(material);
        var interno = (raioInterno * raioInterno) * Math.PI * parseFloat(material);

        var resultado = externo - interno;
        var resultadoPc = (resultado / 1000) * parseFloat(frmBucha.comprimento);

        setFrmBucha({...frmBucha, resultado: resultado, resultadoPc: resultadoPc});
    }







    function formata(num){
        return parseFloat(num).toFixed(2);
    }

    return (
        <>
            <div className="principal">
                <p>Selecione o material:</p>
                <select className="form-control custom-select w-auto" onChange={e => { setMaterial(e.target.value); console.log(e.target.value); }}>
                    <option value={null}>Selecione</option>
                    {materiais.map(mat => {
                        return (
                            <option value={mat.value}>{mat.label}</option>
                        )
                    })}
                </select>
                <br />
                <br />
                <h3>Barra redonda:</h3>
                <div ClassName="alinhamento-tabela">
                    <table>
                        <tr>
                            <td>Diametro (mm)</td>
                            <td>Comprimento (mm)</td>
                            <td>Calcular</td>
                            <td>Resultado</td>
                        </tr>

                        <tr>
                            <td><input type="text campo-imput" onChange={e => { setFrmBarra({ ...frmBarra, diametro: e.target.value }) }} /></td>
                            <td><input type="text campo-imput" onChange={e => { setFrmBarra({ ...frmBarra, comprimento: e.target.value }) }} /></td>
                            <td><button onClick={e => { calcularBarra(); }}>Calcular</button></td>
                            <td>
                                {frmBarra.resultado!==null && <>
                                    Kg/m: {formata(frmBarra.resultado)}<br/>
                                    Kg/pç: {formata(frmBarra.resultadoPc)}<br/>
                                </>}
                            </td>
                        </tr>
                    </table>
                </div>

                <br />
                <h3>Barra quadrada/retangular:</h3>
                <table>
                    <tr>
                        <td>Lado 1 (mm)</td>
                        <td>Lado 2 (mm)</td>
                        <td>Comprimento (mm)</td>
                        <td>Calcular</td>
                        <td>Resultado</td>
                    </tr>

                    <tr>
                        <td><input type="text campo-imput" onChange={e => { setFrmBarraQuadrada({ ...frmBarraQuadrada, lado1: e.target.value }) }} /></td>
                        <td><input type="text campo-imput" onChange={e => { setFrmBarraQuadrada({ ...frmBarraQuadrada, lado2: e.target.value }) }} /></td>
                        <td><input type="text campo-imput" onChange={e => { setFrmBarraQuadrada({ ...frmBarraQuadrada, comprimento: e.target.value }) }} /></td>
                        <td><button onClick={e => { calcularBarraQuadrada(); }}>Calcular</button></td>
                        <td>
                            {frmBarraQuadrada.resultado!==null && <>
                                Kg/m: {formata(frmBarraQuadrada.resultado)}<br/>
                                Kg/pç: {formata(frmBarraQuadrada.resultadoPc)}<br/>
                            </>}
                        </td>
                    </tr>
                </table>

                <br />
                <h3>Bucha:</h3>
                <table>
                    <tr>
                        <td>Externo (mm)</td>
                        <td>Interno (mm)</td>
                        <td>Comprimento (mm)</td>
                        <td>Calcular</td>
                        <td>Resultado</td>
                    </tr>

                    <tr>
                        <td><input type="text campo-imput" onChange={e => { setFrmBucha({ ...frmBucha, externo: e.target.value }) }} /></td>
                        <td><input type="text campo-imput" onChange={e => { setFrmBucha({ ...frmBucha, interno: e.target.value }) }} /></td>
                        <td><input type="text campo-imput" onChange={e => { setFrmBucha({ ...frmBucha, comprimento: e.target.value }) }} /></td>
                        <td><button onClick={e => { calcularBucha(); }}>Calcular</button></td>
                        <td>
                            {frmBucha.resultado!==null && <>
                                Kg/m: {formata(frmBucha.resultado)}<br/>
                                Kg/pç: {formata(frmBucha.resultadoPc)}<br/>
                            </>}
                        </td>
                    </tr>
                </table>



            </div>
        </>
    )
}
export default Home
